<template>
  <span>
    <button class="btn ml-3 pl-3"
            @click="showCreateModal()"
            :class="{'btn-secondary': type == 'secondary', 'btn-success': !type, 'text-success': type == 'global'}"
    >
      <font-awesome-icon icon="plus"/> {{ $t('projects.observations.create_button') }}
    </button>


    <!-- Create observation modal -->
    <b-modal ref="create-observation"
             hide-footer
             @hide="hideCreateModal"
    >
      <div class="d-block text-center">
        <h4 qid="update-tp-title">
          {{ $t('projects.observations.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formSubmit" qid="create-p-form">
        <div>
          <b-form-group v-if="activity && activity.type != 'control_assessment' && activity.type != 'risk_assessment'">
            <label qid="create-s-tags-label">
              {{ $t('projects.observations.create.scope_label') }}
            </label>
            <multiselect
                v-model="selectedScope"
                :options="scopeItems"
                :placeholder="$t('projects.observations.create.scope_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="confidentiality-form-impact"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="activity && activity.type == 'control_assessment'">
            <label qid="create-s-tags-label">
              {{ $t('projects.observations.create.task_label') }}
            </label>
            <multiselect
                v-model="selectedTask"
                :options="tasks"
                :placeholder="$t('projects.observations.create.task_placeholder')"
                label="full_title"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="confidentiality-form-impact"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-name-label">
              {{ $t('projects.observations.create.name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
                qid="create-v-form-name"
                type="text"
                v-model="form.name"
                required
                :maxLength="255"
                :placeholder="$t('projects.observations.create.name_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-description-label">
              {{ $t('projects.observations.create.description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
                qid="create-v-form-description"
                v-model="form.description"
                rows="6"
                max-rows="6"
                required
                :placeholder="$t('projects.observations.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-s-tags-label">
              {{ $t('projects.observations.create.impact_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="selectedImpact"
                :options="impactItems"
                :placeholder="$t('projects.observations.create.impact_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="confidentiality-form-impact"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('systems.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


  </span>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Datepicker from 'vuejs-datepicker';
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'CreateObservationModal',
    data: function() {
      return {
        form: {
          name: '',
          description: '',
          links: []
        },
        editForm: {
          name: '',
          description: '',
          scope_id: '',
          impact_assessment: ''
        },

        activity: {},
        sTableItems: [],
        selectedS: [],
        viewSModal: false,
        sLoading: true,

        DOItems: [],
        tasks: [],
        selectedTask: [],

        error: '',
        itemToDelete: {},
        buttonDisabled: false,

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',

        selectedObservation: {},
        viewObservationModal: false,

        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        impactItems: [
          { name: this.$t('impact.very_low'), value: 'Very low' },
          { name: this.$t('impact.low'), value: 'Low' },
          { name: this.$t('impact.high'), value: 'High' },
          { name: this.$t('impact.very_high'), value: 'Very high' }
        ],
        selectedImpact: [],
        scopeItems: [],
        selectedScope: []
      }
    },
    props: {
      task: {},
      object: {},
      type: {},
      link: '0'
    },
    components: {
      Avatar,
      Datepicker
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if (selectedTo > selectedOf) {
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      },
      object: function (value) {
        this.activity = value;
      }
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadDO(this.keywordValue)
      }, 400),
      resetFile() {
        let imagefile = document.querySelector('#file-p');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file-p');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.form.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.form.links.splice(index, 1);
      },
      showCreateModal() {
        console.log('sssss')
        console.log(this.task)
        this.selectedImpact = []
        this.selectedScope = []
        this.form.name = ''
        this.form.description = ''
        this.loadScopeItems()
        this.loadTasks()

        if (this.task && this.task.id) {
          this.selectedTask = this.task
        }

        this.$refs['create-observation'].show()
      },
      hideCreateModal() {
        this.error = ''
        this.form.links = [];
        this.selectedFiles = [];
        this.$refs['create-observation'].hide()
      },
      loadTasks() {
        let self = this;
        piincHttp.get('projects/' + this.activity.slug + '/tasks', { params:
          {
            client: this.getClient.slug,
            per_page: 100
          }
        }).then(function(response) {
          self.tasks = response.data.items;
        }, function() {});
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        // let files = document.querySelector('#file-p');
        let sizeError = false;

        // Call handle link function to gather link from link input
        this.handleLink()

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        // // Append list of attachments to FormData
        // for (var i = 0; i < files.files.length; i++) {
        //   // Equal to 10 MB
        //   if (files.files[i].size > 10485760) {
        //     sizeError = true;
        //   }
        //   formData.append("files[]", files.files[i]);
        // }
        //
        // // Append list of links to FormData
        // for (var i = 0; i < this.form.links.length; i++) {
        //   formData.append("links[]", JSON.stringify(this.form.links[i]));
        // }

        if (this.selectedImpact && this.selectedImpact.value) {
          formData.append("impact_assessment", this.selectedImpact.value);
        }

        if (this.activity && this.activity.type == 'control_assessment') {
          if (this.selectedTask && this.selectedTask.id) {
            formData.append("scope_id", this.selectedTask.id);
          }
          formData.append("scope_type", this.selectedTask.who_am_i);
        } else {
          if (this.selectedScope && this.selectedScope.id) {
            formData.append("scope_id", this.selectedScope.id);
          }

          if (self.activity.scope && self.activity.scope == 'process') {
            formData.append("scope_type", 'App\\Process\\Models\\Process');
          }
          if (self.activity.scope && self.activity.scope == 'system') {
            formData.append("scope_type", 'App\\System\\Models\\System');
          }
          if (self.activity.scope && self.activity.scope == 'activity') {
            formData.append("scope_type", 'App\\Activity\\Models\\Activity');
          }
          if (self.activity.scope && self.activity.scope == 'third_party') {
            formData.append("scope_type", 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty');
          }
        }

        formData.append("name", this.form.name);
        formData.append("description", this.form.description);
        formData.append("client", this.getClient.slug);

        if (sizeError) {
          this.error = this.$t('system.file_size')
          this.buttonDisabled = false;
        } else {
          if (this.selectedImpact && this.selectedImpact.value) {
            piincHttp.post('/projects/' + this.activity.slug + '/observations', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.$toastr('success', self.$t('projects.observations.create.success'))
              self.hideCreateModal();
              self.buttonDisabled = false;
              self.$emit('updated');
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          } else {
            this.error = '';
            self.buttonDisabled = false;
            if (!this.selectedScope || (this.selectedScope && !this.selectedScope.id)) {
              this.error += this.$t('projects.observations.create.scope_error_message')
            }
            if (!this.selectedImpact || (this.selectedImpact && !this.selectedImpact.value)) {
              this.error += ' ' + this.$t('projects.observations.create.impact_error_message')
            }
          }
        }
      },
      loadScopeItems() {
        let self = this;
        self.scopeItems = []
        piincHttp.get('projects/' + this.activity.slug + '/models', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {

          if (self.activity.scope && self.activity.scope == 'process') {
            _.forEach(response.data.items, function (item) {
              if (item.model && item.model.who_am_i == 'App\\Process\\Models\\Process') {
                self.scopeItems.push(item.model)
              }
            })
          }
          if (self.activity.scope && self.activity.scope == 'system') {
            _.forEach(response.data.items, function (item) {
              if (item.model && item.model.who_am_i == 'App\\System\\Models\\System') {
                self.scopeItems.push(item.model)
              }
            })
          }
          if (self.activity.scope && self.activity.scope == 'activity') {
            _.forEach(response.data.items, function (item) {
              if (item.model && item.model.who_am_i == 'App\\Activity\\Models\\Activity') {
                self.scopeItems.push(item.model)
              }
            })
          }
          if (self.activity.scope && self.activity.scope == 'third_party') {
            _.forEach(response.data.items, function (item) {
              if (item.model && item.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
                self.scopeItems.push(item.model)
              }
            })
          }

          self.sLoading = false;
        }, function() {});
      },
    },
    created () {
      this.activity = this.object;
      if (this.getClient && this.getClient.slug) {
      }

    }
  }
</script>
